module.exports = __webpack_public_path__ + "static/media/tick-square.50b5389b.svg";